import { loc } from "../../../core/utils"
import React from "react"

export default function PartitaIvaTootltipDescription() {
  return (
    <>
      <p className="font-weight-bold mt-1 mb-1">{loc("warningLabel")}</p>
      <p>{loc("partitaIvaWarningdescription")}</p>
    </>
  )
}
